module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "teacher-feedback-wrap"
  }, [(_vm.loading) ? _c('loading') : [_c('div', {
    staticClass: "page-content teacher-feedback-container"
  }, [(_vm.shouldShowReflectiontips) ? _c('a', {
    staticClass: "button-rounded button-rounded--reflection button-rounded--teachertips",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showReflectiontips(_vm.assignment)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--reflection"
  }), _vm._v("Tips")]) : _vm._e(), _c('h2', {
    staticClass: "teacher-feedback__title"
  }, [_vm._v("Feedback")]), (_vm.compliments.length) ? _c('div', {
    staticClass: "input-group"
  }, [_c('h3', [_vm._v("Dit heb je goed gedaan")]), _c('multiselect', {
    attrs: {
      "options": _vm.compliments,
      "track-by": "id",
      "label": "content",
      "searchable": false,
      "close-on-select": true,
      "show-labels": false,
      "multiple": true,
      "hide-selected": true,
      "disabled": _vm.hasFeedbackFromOtherTeacher,
      "placeholder": "Kies (één of meer) tops..."
    },
    model: {
      value: (_vm.feedback.compliments),
      callback: function($$v) {
        _vm.feedback.compliments = $$v
      },
      expression: "feedback.compliments"
    }
  })], 1) : _vm._e(), (_vm.remarks.length) ? _c('div', {
    staticClass: "input-group"
  }, [_c('h3', [_vm._v("Besteed hier nog wat aandacht aan")]), _c('multiselect', {
    attrs: {
      "options": _vm.remarks,
      "track-by": "id",
      "label": "content",
      "searchable": false,
      "close-on-select": true,
      "show-labels": false,
      "multiple": true,
      "hide-selected": true,
      "disabled": _vm.hasFeedbackFromOtherTeacher,
      "placeholder": "Kies (één of meer) tips..."
    },
    model: {
      value: (_vm.feedback.remarks),
      callback: function($$v) {
        _vm.feedback.remarks = $$v
      },
      expression: "feedback.remarks"
    }
  })], 1) : _vm._e(), _c('h3', [_vm._v("Opmerkingen")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.feedback.content),
      expression: "feedback.content"
    }],
    staticClass: "teacher-feedback",
    attrs: {
      "placeholder": "",
      "readonly": _vm.hasFeedbackFromOtherTeacher
    },
    domProps: {
      "value": (_vm.feedback.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.feedback.content = $event.target.value
      }
    }
  }), _c('h2', [_vm._v("Beoordeling")]), _c('Diligence', {
    attrs: {
      "progress": _vm.progress,
      "isDemo": _vm.isDemo
    },
    on: {
      "input": function($event) {
        _vm.diligence = $event
      }
    }
  }), (_vm.progress.isRetaking) ? _c('p', {
    staticClass: "note note--large note--warning"
  }, [_c('span', {
    staticClass: "icon icon--inline icon--retake-dark"
  }), _vm._v(" Deze opdracht wordt overgedaan.")]) : _c('p', [_c('a', {
    staticClass: "tag button-timid button--retake-assignment",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.retakeAssignment
    }
  }, [_c('span', {
    staticClass: "icon icon--inline icon--retake-dark"
  }), _vm._v(" Laat " + _vm._s(_vm.reviewee.firstname) + " opdracht overdoen")])]), _c('Badges', {
    attrs: {
      "progress": _vm.progress,
      "isDemo": _vm.isDemo,
      "disabled": _vm.diligence !== 'sufficient'
    }
  })], 1), _c('nav', {
    staticClass: "action-nav"
  }, [_c('hr', {
    staticClass: "flipped"
  }), _c('router-link', {
    staticClass: "show-group-submissions tag button-timid button-forward",
    attrs: {
      "to": {
        name: 'group.assignment.group',
        params: {
          periodId: _vm.periodIdForAssignment(_vm.assignment)
        }
      }
    }
  }, [_vm._v("Klasoverzicht " + _vm._s(_vm.assignment.title))]), _c('primary-button', {
    staticClass: "action-nav__next",
    attrs: {
      "link": _vm.returnLink.route
    }
  }, [_vm._v("Klaar")])], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80654614","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/assignment/TeacherFeedback.vue
// module id = Sqyl
// module chunks = 1